import React from 'react';
import { compose } from 'redux';
import { isVAOnHelpCenterGAEnabled } from '@helpcenter/feature-flags';
import { withAsync } from '@helpcenter/with-async';
import { useIntl } from 'react-intl-next';
import { lazyForPaint } from 'react-loosely-lazy';
import { withRouter, type Route } from 'react-resource-router';
import { withJsmAiConfigEnabled } from 'view/common/with-jsm-ai-config';
import { withOnlyJiraAdmin } from 'view/common/with-only-jira-admin';
import { withOnlyLoggedIn } from 'view/common/with-only-logged-in';
import { authPageMessage, callToActionUrlText } from 'view/portal-reorder-experience';
import { AdminManagementLayout } from '@atlassian/admin-layout';
import messages from '@atlassian/help-center-reporting/src/ui/messages';
import { HelpCenterVirtualAgentResource } from '@atlassian/help-center-virtual-agent-settings/src/resource';

const AsyncVirtualAgentPage = withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-help-center-virtual-agent-page" */ '@atlassian/help-center-virtual-agent-settings'
        ).then((VirtualAgentSettingsPage) => VirtualAgentSettingsPage)
    ),
});

const VirtualAgentPage = () => {
    const { formatMessage } = useIntl();
    const WrappedComponent = compose(
        withOnlyLoggedIn({
            redirectUrl: '/',
        }),
        withOnlyJiraAdmin({
            message: formatMessage(authPageMessage),
            callToActionText: formatMessage(callToActionUrlText),
            callToActionUrl: '/portals',
        }),
        ...(isVAOnHelpCenterGAEnabled()
            ? []
            : [
                  withJsmAiConfigEnabled({
                      message: formatMessage(messages.aiConfigNotEnabledError),
                      callToActionText: formatMessage(callToActionUrlText),
                      callToActionUrl: '/portals',
                  }),
              ])
    )(() => (
        <AdminManagementLayout featureName="Virtual Agent Settings">
            <AsyncVirtualAgentPage />
        </AdminManagementLayout>
    ));
    return <WrappedComponent />;
};

export const helpcenterVirtualAgentRoute: Route = {
    name: 'virtualAgentSettings',
    path: '/:helpcenterId/virtual-agent',
    exact: true,
    resources: [HelpCenterVirtualAgentResource],
    component: withRouter(VirtualAgentPage),
};
